var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.27 3.938-1.551-.69-.691-1.553-1.689.176L6.965.875l-1.374.996-1.688-.176-.69 1.552-1.553.69.177 1.69L.84 7l.997 1.375-.177 1.688 1.552.69.69 1.552 1.69-.176 1.373.996 1.375-.996 1.688.176.69-1.552 1.552-.69-.176-1.69L13.09 7l-.996-1.375zM5.74 9.45 4.007 7.717l.578-.576L5.74 8.294 9.205 4.83l.578.577z"
  })));
};
export default SvgCheck;